import script from "./PortfolioTokenList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioTokenList.vue?vue&type=script&setup=true&lang=ts"

import "./PortfolioTokenList.vue?vue&type=style&index=0&id=5088c918&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5088c918"]])

export default __exports__